<script>
export default {
  name: 'IconWrapper',
}
</script>

<!-- 
  <i> and .fa to match font-awesome integration.
 `aria-label=""` can be owerwritten during integration.
-->

<template>
  <i class="Icon IconWrapper fa" role="img" aria-label=""></i>
</template>

<style lang="scss">
.Icon {
  display: inline-flex !important; // owerwritte .fa inline-block
  justify-content: center;
  align-items: center;
  font-size: 1em;
  
  & svg {
    width: 1em;
    height: 1em;

    path,
    polygon,
    rect,
    circle,
    ellipse,
    line,
    polyline {
      fill: currentColor;
    }
  }
}
</style>